import NextLink from "next/link";

import { IcArrowRight } from "@jetblue/kit-icons/ic-arrow-right";
import { IcBullet } from "@jetblue/kit-icons/ic-bullet";

import { Button, type ButtonProperties } from "@jetblue/kit/button";
import { List } from "@jetblue/kit/list";

import type { ListItemProperties } from "@jetblue/kit/list";

type UnauthenticatedLinkButtonCTA = {
  href: string;
  isExternal: boolean;
  label: string;
  target?: "_blank" | "_self";
  variant?: ButtonProperties["variant"];
};

export type UnauthenticatedCallToActionsProperties = {
  ctaLinkOne?: UnauthenticatedLinkButtonCTA;
  ctaLinkTwo?: UnauthenticatedLinkButtonCTA;
  listItems?: ListItemProperties[];
  title?: string;
};
export const CallToActions = ({
  ctaLinkOne,
  ctaLinkTwo,
  listItems,
  title,
}: UnauthenticatedCallToActionsProperties) => (
  <section className="border-t border-border-default p-6">
    {title && (
      <h3 className="text-title-m font-semibold text-foreground-primary-variant">
        {title}
      </h3>
    )}

    {listItems && <List Icon={IcBullet} className="mt-2" items={listItems} />}

    {ctaLinkOne && (
      <Button
        as={NextLink}
        className="mt-4"
        data-fs-element="user-unauthenticated-primary-cta-link"
        href={ctaLinkOne.href}
        isFullWidth
        size="large"
        variant={ctaLinkOne.variant}
      >
        {ctaLinkOne.label}
      </Button>
    )}

    {ctaLinkTwo && (
      <NextLink
        className="
          mt-4 block text-center text-label font-extrabold
          text-foreground-primary focus-outline

          hover:text-foreground-primary-variant hover:underline
        "
        data-fs-element="user-unauthenticated-secondary-cta-link"
        href={ctaLinkTwo.href}
        target={ctaLinkTwo.target}
      >
        <span>{ctaLinkTwo.label}</span>

        <IcArrowRight className="ms-1 inline size-2" />
      </NextLink>
    )}
  </section>
);
